<script>
import { mapState, mapGetters } from 'vuex'
import deepLink from '@/mixins/deeplink.js'
import rappiUtils from '@/mixins/rappi-utils.js'
import AMPLITUDE from '@constants/amplitude'
import GTM_CONSTANTS from '@constants/google-tag-manager'
const DEVICE_ANDROID = 'Android'

export default {
  name: 'CloseRequest',
  mixins: [rappiUtils(), deepLink()],
  props: {
    token: {
      type: String,
      required: true,
    },
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('widgets', ['widgetProperty', 'userEnv']),
    ...mapState('widgets', {
      userOS: state => state.common.user.os,
    }),
    orderData () {
      return this.widgetProperty('SharedData', 'orderData')
    },
    calificationValue () {
      return this.widgetProperty('Rate', 'value')
    },
    payloadForlogs () {
      const payload = Object.assign({}, this.$route.params, this.$route.query)
      delete payload.token;

      return payload
    },
    app () {
      return app || this.app // eslint-disable-line
    },
  },
  methods: {
    closeRequest () {
      this.$emit('onChildChange', { fetching: true })
      this.calificateOrder(
        this.token,
        this.orderData.id,
        this.calificationValue
      )
        .then(order => {
          return this.finalizeOrder(this.token, this.orderData.id)
        })
        .then(order => {
          const deeplink =
            this.userOS === DEVICE_ANDROID &&
              parseInt(this.calificationValue, 10) === 5
              ? `goto=rating&rate=${this.calificationValue}`
              : 'goto=home'
          this.callDeepLink(deeplink)
          this.$emit('onChildChange', { fetching: false })
        })
        .catch(err => {
          this.dispatchEventTrack(
            AMPLITUDE.SERVER_ERROR,
            JSON.parse(JSON.stringify(err))
          )
          this.callDeepLink('goto=home')
          this.$emit('onChildChange', { fetching: false })
        })
    },
    dispatchEventTrack (eventName, payload = this.payloadForlogs) {
      this.$gtm.trackEvent({
        event: GTM_CONSTANTS.LOG_EVENT,
        noninteraction: eventName,
        payload,
        eventType: eventName,
        user: this.userForLogs,
      })
    },
  },
  dispatchEventTrack (eventName, payload = this.payloadForlogs) {
    this.$gtm.trackEvent({
      event: GTM_CONSTANTS.LOG_EVENT,
      noninteraction: eventName,
      payload,
      eventType: eventName,
      user: this.userForLogs,
    })
  },
}
</script>

<template>
  <div :class="$style.btnContainer">
    <BaseButton
      :disabled="!(calificationValue > 3)"
      full
      @click="closeRequest()"
    >
      {{ $t('WIDGETS.CLOSE_REQUEST.TITLE') }}
    </BaseButton>
  </div>
</template>

<style scoped lang="scss" module>
@import '@design';

.btnContainer {
  width: 100%;
  padding: 0.5rem 0;
  padding-bottom: 1.5rem;
}
</style>
